import React from "react";
import { CONTACT_PAGE, HOME_PAGE } from "../../Constants";

export default function Information() {
  const getInContactWithUs = () => {
    return (
      <h4 className="font-weight-normal">
        if you are still facing issues{" "}
        <a href={CONTACT_PAGE} target="_blank" rel="noreferrer">
          Contact Us
        </a>{" "}
      </h4>
    );
  };
  return (
    <div className="left-align-text" style={{ paddingLeft: 100 }}>
      <h1>Information</h1>
      <div className="paddingtop20">
        <h2>How to Use</h2>
        <div className="fa-left-padding paddingtop20">
          <h3 className="font-weight-normal">
            1. To use this service you need a PC (Laptop or Desktop) and a smart
            phone device.
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            2. Go to{" "}
            <a href={HOME_PAGE} target="_blank" rel="noreferrer">
              Home Page
            </a>{" "}
            on Laptop or Desktop ONLY - Not for mobile (sign-in if not signed in
            already).
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            3. Click "Start" button to select the content of your stream.
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            4. Go to{" "}
            <i>
              <b>
                {process.env.REACT_APP_FE_HOST ?? "https://head3dio.com"}/view
              </b>
            </i>{" "}
            on your smart phone device (via browser of your choice).
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            5. Enter the pairing pin into pairing pin input field on Laptop or
            Desktop device
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            6. Click "Pair" button to establish connection. Follow instructions
            on smart phone device.
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            7. Select an environment to render your content and step into a new
            realm via VR headset.
          </h3>
        </div>
      </div>
      <h2>___________________________</h2>
      <div className="paddingtop20">
        <h2>Troubleshooting Tips</h2>
        <div className="fa-left-padding paddingtop20">
          <h3 className="font-weight-normal">
            <u>Nothing happens when I click on Pair button to connect</u>
            <div className="fa-left-padding paddingtop20">
              <ul className="fa-left-padding">
                <li>Reload pages on both PC and mobile device.</li>
                <li>
                  Make sure you enter all charcters shown on the phone into the
                  pairing pin field on PC. Keep in mind that it is case
                  sensitive
                </li>
                <li>{getInContactWithUs()}</li>
              </ul>
            </div>
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            <u>I see a black screen/I can't see my PC screen on my mobile</u>
            <div className="fa-left-padding paddingtop20">
              <ul className="fa-left-padding">
                <li>
                  Disconnect and reconnect Wi-Fi on both PC and mobile. Try
                  streaming few more time using pairing pin
                </li>

                <li>
                  {" "}
                  if that does not work then restart your PC and mobile device
                  and try again
                </li>
                <li>{getInContactWithUs()}</li>
              </ul>
            </div>
          </h3>
          <h3 className="font-weight-normal paddingtop20">
            <u>My stream is lagging</u>
            <div className="fa-left-padding paddingtop20">
              <ul className="fa-left-padding">
                <li>
                  Recommended browsers: PC -{">"} Google Chrome, Android -{">"}{" "}
                  Google Chrome BETA, iOS -{">"} Safari. Make sure they are
                  updated to the latest version.
                </li>
                <li>
                  Make sure low power mode is turned off on PC and the mobile
                  device
                </li>
                <li>
                  If the stream starts to lag again then disconnect Wi-Fi on
                  phone and reconnect after 4 seconds (Do not close or minimize
                  browser during the process)
                </li>
                <li>
                  <b>Multi threaded stream users only:</b> If your phone has
                  mobile data then swtich to using mobile data. Then connect to
                  Head3d's VR service. If the stream is still lagging then
                  switch back to Wi-Fi without closing/minimizing the browser
                </li>
                <li>{getInContactWithUs()}</li>
              </ul>
            </div>
          </h3>
        </div>
      </div>
    </div>
  );
}
